import translation from '@elements/translation';
import { numberOptionalDecimal } from '@elements/number-formatter';
import { URL_OFFER_VIEW } from '@tools/routes/routes';
import OFFICE_TYPE from './offer/office-type-enum';

export default {
  mixins: [ translation ],
  computed: {
    getCapacity() {
      // don't show capacity for one open space
      if (this.isSingleOpenSpace) {
        return 0;
      }

      // Show team size if filled by buyer
      if (this.deal.buyer_team_size) {
        return this.deal.buyer_team_size;
      }

      return this.getCapacitySum;
    },
    getCapacitySum() {
      let teamSize = 0;
      this.deal.office_offers_collection.forEach((officeOffer) => {
        teamSize += officeOffer.team_size;
      });

      return teamSize;
    },
    getAmount() {
      // This calculation comes from https://bureaux-a-partager.atlassian.net/browse/MATCH-7154
      let amount = 0;
      for (let i = 0; i < this.deal.office_offers_collection.length; i++) {
        const selectionItemOfficeOffer = this.deal.office_offers_collection[i];
        const offer = selectionItemOfficeOffer.office_offer;

        if (offer.office_type.code === OFFICE_TYPE.OPEN_SPACE) {
          amount += offer.price * selectionItemOfficeOffer.team_size;
        }

        if ([ OFFICE_TYPE.INDEPENDENT, OFFICE_TYPE.PRIVATE ].includes(offer.office_type.code)) {
          amount += offer.price;
        }
      }
      return amount;
    },
    getAmountPerPerson() {
      return numberOptionalDecimal(this.getAmount / this.getCapacity, 2);
    },
    isMultiBureau() {
      return this.deal.office_offers_collection.length > 1;
    },
    getOfficeType() {
      if (this.isMultiBureau) {
        return this.trans('inbox.combinaison.title');
      }
      return this.deal.first_office_offer.office_type.name;
    },
    isSingleOpenSpace() {
      return this.deal.office_offers_collection.length === 1
        && this.deal.first_office_offer.office_type.code === OFFICE_TYPE.OPEN_SPACE;
    },
    getOffersNameList() {
      return this.deal.office_offers_collection.map((relation) => relation.office_offer.name).join(', ');
    },
    getUrl() {
      let { uri } = this.deal.office_offers_collection[0].office_offer;
      for (let i = 0; i < this.deal.office_offers_collection.length; i++) {
        if (this.deal.office_offers_collection[i].office_offer.state === 'published') {
          uri = this.deal.office_offers_collection[i].office_offer.uri;
          break;
        }
      }

      const hashIdList = this.deal.office_offers_collection.map((o) => o.office_offer.hash_id);
      const teamSizeList = this.deal.office_offers_collection.map((o) => o.team_size);

      if (!hashIdList || hashIdList.length === 0) {
        return uri;
      }

      return `${uri}?selected_offers=${hashIdList.join('|')}&team-size-list=${teamSizeList.join('|')}`;
    },
  },
  methods: {
    offerPrivateUrl(offer) {
      return URL_OFFER_VIEW.replace('{id}', offer.office_offer.hash_id);
    },
  },
};
